import { useEffect, useState } from "react";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from "recharts";
import { BarChart3, Loader2 } from "lucide-react";
import { api } from "../lib/api";

const MONTHS_AR = ["يناير", "فبراير", "مارس", "أبريل", "مايو", "يونيو", "يوليو", "أغسطس", "سبتمبر", "أكتوبر", "نوفمبر", "ديسمبر"];
const label = (m) => { const [y, mm] = String(m).split("-"); const i = Number(mm) - 1; return i >= 0 && i < 12 ? `${MONTHS_AR[i]} ${String(y).slice(2)}` : m; };
const fmt = (v) => Number(v || 0).toLocaleString("en-US");

export const MonthlyComparisonCard = () => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.getMonthlyComparison()
      .then((d) => setRows((d || []).map((r) => ({ ...r, label: label(r.month) }))))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="rounded-2xl border border-slate-200 bg-white p-4 space-y-3" data-testid="monthly-comparison-card">
      <div className="flex items-center gap-2">
        <div className="flex h-9 w-9 items-center justify-center rounded-xl bg-violet-50 text-violet-600"><BarChart3 className="h-5 w-5" /></div>
        <div>
          <h3 className="font-heading text-base font-bold text-slate-900">المقارنة الشهرية</h3>
          <p className="text-[11px] text-slate-500">الدخل والمصروفات والصافي شهراً بشهر</p>
        </div>
      </div>
      {loading ? (
        <div className="py-10 text-center text-slate-400"><Loader2 className="mx-auto h-6 w-6 animate-spin" /></div>
      ) : rows.length === 0 ? (
        <div className="py-8 text-center text-sm text-slate-400" data-testid="monthly-comparison-empty">
          لا توجد بيانات بعد. ارفع فواتير شهرية وأدخل كلفة المندوب لتظهر المقارنة.
        </div>
      ) : (
        <ResponsiveContainer width="100%" height={300}>
          <BarChart data={rows} margin={{ top: 5, right: 10, left: 0, bottom: 0 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="#eef2f7" />
            <XAxis dataKey="label" tick={{ fontSize: 11 }} />
            <YAxis tick={{ fontSize: 11 }} tickFormatter={fmt} width={54} />
            <Tooltip formatter={(v) => `${fmt(v)} ⃁`} />
            <Legend wrapperStyle={{ fontSize: 12 }} />
            <Bar dataKey="income" name="الدخل" fill="#059669" radius={[5, 5, 0, 0]} />
            <Bar dataKey="expenses" name="المصروفات" fill="#dc2626" radius={[5, 5, 0, 0]} />
            <Bar dataKey="profit" name="الصافي" fill="#2563eb" radius={[5, 5, 0, 0]} />
          </BarChart>
        </ResponsiveContainer>
      )}
    </div>
  );
};
